import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full'
import ModalNPS from '@/views/components/modalnps.vue'
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
Vue.component('modal-nps', ModalNPS)

Vue.filter('capitalizeFirstLetter', (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
})
Vue.filter('capitalizeEachWord', (string) => {
    string = string.toLowerCase()
    return string.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
})


